document.addEventListener('DOMContentLoaded', function () {
  let toggleElements = document.querySelectorAll('.rte-truncate.product-description-tab-container') || false;

  if (toggleElements) {
    toggleElements.forEach((toggleEl) => 
      // Code to execute for each element
      toggleEl.addEventListener('click', function () {
        this.classList.toggle('expanded');
      })
    );
  }
});